module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_5.faf2144.webp";